const full = (pattern, value) => typeof value === "string" && pattern.exec(value)?.[0] === value;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
export function validateRetryPreview(value, { batchId, action, inputSeq, page = 0 }) {
  const data = value?.data;
  if (value?.code !== 0 || !data || new TextEncoder().encode(JSON.stringify(value)).length > 131072)
    throw new Error("재발급 대상 확인에 실패했습니다.");
  if (data.journalEnabled === false) return data;
  if (
    data.journalEnabled !== true ||
    data.batchId !== batchId ||
    data.action !== action ||
    !full(UUID, data.parentOperationId) ||
    !full(/^[a-f0-9]{64}$/, data.previewSha256) ||
    !["1", "2"].includes(data.issueType) ||
    data.completeSelectionVerified !== true ||
    !Number.isInteger(data.targetCount) ||
    data.targetCount < 0 ||
    data.targetCount > 10000 ||
    data.totalPages !== Math.max(1, Math.ceil(data.targetCount / 128)) ||
    data.page !== page ||
    page < 0 ||
    page >= data.totalPages ||
    !Array.isArray(data.targets) ||
    data.targets.length !== Math.min(128, Math.max(0, data.targetCount - page * 128))
  )
    throw new Error("재발급 대상 정보가 완전하지 않습니다.");
  const inputs = new Set();
  const items = new Set();
  const attempts = new Set();
  for (const target of data.targets) {
    if (
      !Number.isSafeInteger(target.inputSeq) ||
      target.inputSeq < 1 ||
      !Number.isSafeInteger(target.itemSeq) ||
      target.itemSeq < 1 ||
      inputs.has(target.inputSeq) ||
      items.has(target.itemSeq) ||
      (action === "reissue" && (target.inputSeq !== inputSeq || data.targetCount !== 1)) ||
      (target.unknownAttemptId !== null &&
        (!full(UUID, target.unknownAttemptId) || attempts.has(target.unknownAttemptId)))
    )
      throw new Error("재발급 대상과 이전 시도를 확인할 수 없습니다.");
    for (const key of ["registerType", "uniqueNo", "searchAddress", "buildingDong", "buildingHo"])
      if (target[key] !== null && (typeof target[key] !== "string" || target[key].length > 8192))
        throw new Error("재발급 대상 표시가 잘못되었습니다.");
    inputs.add(target.inputSeq);
    items.add(target.itemSeq);
    attempts.add(target.unknownAttemptId);
  }
  return data;
}
export function retryApprovalBody(pages, reviewed, acknowledged) {
  const first = pages[0];
  if (!first || first.journalEnabled !== true || first.targetCount === 0 || pages.length !== first.totalPages)
    throw new Error("모든 재발급 대상을 확인하세요.");
  const unknown = [];
  const inputs = new Set();
  const items = new Set();
  pages.forEach((page, index) => {
    if (
      !page ||
      page.page !== index ||
      page.previewSha256 !== first.previewSha256 ||
      page.parentOperationId !== first.parentOperationId ||
      page.batchId !== first.batchId ||
      page.action !== first.action ||
      page.targetCount !== first.targetCount ||
      reviewed[index] !== true
    )
      throw new Error("최신 대상의 모든 페이지를 다시 확인하세요.");
    page.targets.forEach(target => {
      if (inputs.has(target.inputSeq) || items.has(target.itemSeq)) throw new Error("대상 정보가 중복되었습니다.");
      inputs.add(target.inputSeq);
      items.add(target.itemSeq);
      if (target.unknownAttemptId !== null) {
        if (unknown.includes(target.unknownAttemptId) || acknowledged[target.unknownAttemptId] !== true)
          throw new Error("결과 불명 시도에 개별 동의가 필요합니다.");
        unknown.push(target.unknownAttemptId);
      }
    });
  });
  if (inputs.size !== first.targetCount) throw new Error("전체 대상 확인이 필요합니다.");
  return {
    parentOperationId: first.parentOperationId,
    previewSha256: first.previewSha256,
    approvedUnknownAttemptIds: unknown,
  };
}
